export enum ProjectStatus {
    DRAFT = 'draft',
    PUBLISHED = 'published'
}

export interface Project {
    id: string;
    name: string;
    status: ProjectStatus;
    repository?: {
        name: string;
        fullName: string;
        owner: string;
    };
    framework?: string;
    createdAt: string;
    updatedAt: string;
    deployments?: Deployment[];
    url?: string;
    /** URL of the deployed application, derived from deployment.service_url or deployment.custom_domain */
    deploymentUrl?: string;
    branch?: string;
    icon?: string;
    ownerName?: string;
    ownerImage?: string;
    onDelete?: (id: string) => Promise<void>;
    onDuplicate?: (id: string) => Promise<void>;
    repo?: string;
    update?: string;
    time?: string;
    isPublished?: boolean;
    isQuickStart?: boolean;
}

export interface Deployment {
    projectSlug: string;
    build_url: string;
    createdAt: string;
    deployment_id: string;
    githubUsername: string;
    isActive: boolean;
    message: string;
    orgId: string | null;
    service_url: string;
    status: 'completed' | 'failed' | 'in_progress';
    timestamp: string;
    updatedAt: string;
    userId: string;
    custom_domain?: string;  // Optional custom domain for the deployment
}

export enum SidebarTab {
    Editor = "editor",
    Preview = "preview",
}